import { render, staticRenderFns } from "./category-edit.vue?vue&type=template&id=1babf2b2&"
import script from "./category-edit.vue?vue&type=script&lang=ts&"
export * from "./category-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports